import React, { useEffect, useRef, useState, useImperativeHandle } from 'react';
import {
  isMobileFun,
  getQueryString,
  convertStylesStringToObject,
  createFilePath,
  GotoMall,
  getPathnameByPosition,
  GotoFansApp
} from '../../utils/obj-utils';
import './style.scss';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.min.css';
import temp from '../../temp/config';
import { dataFetcher } from '../../dataFetcher';

export default function index(props) {
  if (!props?.showFooter && !props?.fields?.flag?.value) {
    return null;
  }
  const gwOwncenter = `${temp.app.mall}gwOwn/center`;
  const gwOwnlogin = `${temp.app.mall}gwOwn/login`;
  const { fields } = props;
  const [menunum, setMenunum] = useState(-1);
  const [carindex, setCarindex] = useState(0);
  const [secordindex, setSecordindex] = useState(0);
  const [inputFlag, setInputFlag] = useState(false);
  const [meauFlag, setMeauFlag] = useState(false);
  const [isFirstPageFlag, setIsFirstPageFlag] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const isMobile = isMobileFun();
  const swiperEl = useRef(null);
  const swiperEr = useRef(null);
  const showmeauRef = useRef(null);
  const sublogoRef = useRef(null);
  const logo = fields.logo.value.replaceHtml() ? JSON.parse(fields.logo.value.replaceHtml()) : '';
  const menu = fields.menu.value.replaceHtml() ? JSON.parse(fields.menu.value.replaceHtml()) : '';
  const car = fields.car.value.replaceHtml() ? JSON.parse(fields.car.value.replaceHtml()) : '';
  const othermenu = fields.othermenu.value.replaceHtml() ? JSON.parse(fields.othermenu.value.replaceHtml()) : '';
  const pagetype = props?.params?.pagetype || ''; // 判断不同页面 不用样式对应
  const headerClass =
    pagetype === 'home'
      ? 'Header_V1_Home'
      : pagetype === 'enp'
      ? 'Header_V1_Black'
      : pagetype === 'car'
      ? 'Header_V1_Car'
      : pagetype === 'zrv'
      ? 'Header_V1_Black'
      : pagetype === 'p7'
      ? 'Header_V1_Blue'
      : '';

  // 用户中心以及登陆逻辑
  function backUrl(bool, page) {
    var backurl = document.referrer;
    if (backurl) {
      if (getQueryString('type') === 'home') {
        if (bool) {
          window.location.href = '/member/home';
        } else {
          setTimeout(() => {
            window.history.go(-2);
          }, 500);
        }
      } else {
        setTimeout(() => {
          window.history.go(-2);
        }, 500);
      }
    }
  }
  function getMembermobileValue(mobile) {
    if (mobile) {
      sessionStorage.removeItem('MemberCarInfo');
      sessionStorage.setItem('MembermobileValue', mobile); // 手机号码存到session
      dataFetcher('/api/honda/v1/DMP/GetSafeUserTag?mobile=' + mobile)
        .then(({ data }) => {
          if (data.Status) {
            if (data?.Data?.retCode === 200 && data?.Data?.result.length > 0) {
              sessionStorage.setItem('MemberCarInfo', JSON.stringify(data?.Data?.result)); // 用户信息存到session
              backUrl(true, '-2');
            } else {
              backUrl(false, '-2');
            }
          } else {
            backUrl(false, '-2');
          }
        })
        .catch((error) => {
          backUrl(false, '-2');
        });
    }
  }
  function GetDMPEncodePhoneNo(mobile) {
    if (mobile) {
      dataFetcher('/api/honda/v1/DMP/GetDMPEncodePhoneNo?mobile=' + mobile)
        .then((res) => {
          if (res?.data?.Status) {
            if (res?.data?.Data?.code === 0 && res?.data?.Data?.data?.encodedata) {
              sessionStorage.setItem('MembermobileValue2', mobile);
              sessionStorage.setItem('urlMembermobileValue', res?.data?.Data?.data?.encodedata);
              setlocationhistory(res?.data?.Data?.data?.encodedata, props?.page?.fields?.personalized_enable?.value, 'tel');
            }
          } else {
            return Promise.reject(new Error(res?.data?.ErrorResult?.ErrMsg));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  var eventJson;
  function membermessage(event) {
    // 把子窗口发送过来的数据显示在父窗口中
    if (event.data && event.data?.landed !== undefined) {
      // 保客获取手机号码复制到url(商城)
      if (
        event.data.mobile &&
        (!sessionStorage.getItem('MembermobileValue2') || sessionStorage.getItem('MembermobileValue2') !== event.data.mobile)
      ) {
        GetDMPEncodePhoneNo(event.data.mobile);
      }
      if (event.data.backHome !== undefined && event.data.backHome) {
        document.getElementById('centerIframe').setAttribute('src', '');
        backUrl(false, '-1');
      }
      if (event.data.landed) {
        if (event.data.action && (event.data.action === 'login' || event.data.action === 'regist')) {
          getMembermobileValue(event.data.mobile);
        }
      } else {
        sessionStorage.removeItem('MemberCarInfo');
        sessionStorage.removeItem('MembermobileValue');
      }
      if (JSON.stringify(eventJson) !== JSON.stringify(event.data)) {
        eventJson = event.data;
        var val = document.querySelector('.userName');
        // var val2 = document.querySelector('.userName2');
        if (event.data.landed) {
          val.innerHTML = event.data.nickName;
          val.classList.add('redUserName');
          // val2.classList.add('redUserName');
          if (document.getElementById('centerIframe')) {
            document.getElementById('centerIframe').setAttribute('src', gwOwncenter);
            if (isMobile) {
              document.getElementById('centerIframe').setAttribute('height', document.documentElement.clientHeight + 200);
            } else {
              if (event.data.isDwpMember) {
                document.getElementById('centerIframe').setAttribute('height', '1900');
              } else {
                document.getElementById('centerIframe').setAttribute('height', '1200');
              }
            }
          }
        } else {
          val.classList.remove('redUserName');
          // val2.classList.remove('redUserName');
          val.innerHTML = '请登录';
          if (document.getElementById('centerIframe')) {
            document.getElementById('centerIframe').setAttribute('src', gwOwnlogin);
            if (isMobile) {
              document.getElementById('centerIframe').style.height = '100vh';
            } else {
              document.getElementById('centerIframe').setAttribute('height', '550px');
            }
          }
        }
      }
    }
  }
  function onload() {
    setTimeout(() => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.allowFullScreen = '';
      iframe.id = 'iframePopup';
      iframe.width = '0';
      iframe.height = '0';
      iframe.src = `${temp.app.mall}gwOwn/loginStatus?sts=off`;
      iframe.name = 'iframePopup';
      iframe.className = 'iframe_homePage';
      if (document.querySelector('.headerLogo')) {
        document.querySelector('.headerLogo').appendChild(iframe);
      }
    }, 0);
  }
  useEffect(() => {
    onload();
    var MemberHtmllocation = window.location.href;
    if (getQueryString('MembermobileValue') && MemberHtmllocation.indexOf('/center') !== -1) {
      // url带参
      getMembermobileValue(getQueryString('MembermobileValue'));
    }

    if (window.attachEvent) {
      window.attachEvent(
        'message',
        function (event) {
          membermessage(event);
        },
        false
      );
    } else if (window.addEventListener) {
      window.addEventListener('message', function (event) {
        membermessage(event);
      });
    }
    if (document.getElementById('centerIframe')) {
      document.getElementById('centerIframe').onload = function () {
        setTimeout(function () {
          document.getElementById('centerIframe').contentWindow.postMessage(
            {
              source: 2
            },
            gwOwnlogin
          );
        }, 500);
      };
    }
  }, []);
  // 用户中心以及登陆逻辑结束

  const windowhidden = () => {
    document.documentElement.style.overflow = 'hidden';
  };
  const closewindowhidden = () => {
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.overflowX = 'hidden';
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (document.documentElement.scrollTop > document.documentElement.clientHeight - 60) {
        setIsFirstPageFlag(false);
      } else {
        setIsFirstPageFlag(true);
      }
    });
  });

  // 事件监听器，m端点击元素以外隐藏菜单栏
  useEffect(() => {
    if (!isMobile) {
      return;
    }
    const handleClickOutside = (event) => {
      if (showmeauRef.current && !showmeauRef.current.contains(event.target) && !sublogoRef.current.contains(event.target)) {
        setMeauFlag(false);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  // m端滑动隐藏菜单栏
  useEffect(() => {
    if (!isMobile) {
      return;
    }
    const scroll = () => {
      if (document.documentElement.scrollTop > 60) {
        setMeauFlag(false);
      }
    };
    window.addEventListener('scroll', scroll);
    return () => {
      window.removeEventListener('scroll', scroll);
    };
  }, []);

  return (
    <div
      className={`Header_v1 ${fields.className.value} ${headerClass} ${pagetype === 'home' ? (isFirstPageFlag ? 'Home_first' : 'Home_ohter') : ''}`}
    >
      {logo && ( // logo
        <a
          className={`logo headerLogo ${pagetype === 'enp' || pagetype === 'p7' ? 'headerLogoblack' : ''}`}
          style={convertStylesStringToObject(logo.style)}
          data-html-item={logo.dmp}
          data-url={logo.url}
          href={logo.url}
          target={logo.target || '_self'}
        >
          <img
            className="icon"
            src={createFilePath(pagetype === 'enp' || pagetype === 'p7' ? logo.blackimg : pagetype === 'zrv' ? logo.zrvimg : logo.img)}
            alt="广汽本田"
          />
        </a>
      )}
      {othermenu &&
        isMobile && ( // m端右侧菜单
          <div className="othermenu mobileothermenu" style={convertStylesStringToObject(othermenu.style)}>
            {othermenu.lists.map((item, index) => {
              return (
                item.iscenter && (
                  <a
                    key={index}
                    className={`link ${item.btnclass}`}
                    style={convertStylesStringToObject(item.style)}
                    data-html-item={item.dmp}
                    data-url={item.url}
                    href={item.url}
                    target={item.target || '_self'}
                    rel={item.nofollow || ''}
                    dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                  ></a>
                )
              );
            })}
            <div
              className="meaubtn"
              ref={sublogoRef}
              onClick={() => {
                setMeauFlag(!meauFlag);
                window.Dmp.decideAction(othermenu.menudmp, !meauFlag);
              }}
            ></div>
          </div>
        )}
      {(meauFlag || !isMobile) && ( // 总菜单
        <div
          className={`menubox ${pagetype === 'enp' || pagetype === 'p7' ? 'menuboxblack' : ''}`}
          style={convertStylesStringToObject(menu.boxstyle)}
          ref={showmeauRef}
        >
          {menu && (
            <div className="menu" style={convertStylesStringToObject(menu.style)}>
              {menu.lists.map((item, index) => {
                return (
                  <div className={`menuitem ${menunum === index ? 'on' : ''}`} key={index}>
                    {item.title ? (
                      item.isurl ? ( // 外链
                        <a
                          className="menulink"
                          style={convertStylesStringToObject(item.style)}
                          data-html-item={item.dmp}
                          data-url={item.url}
                          href={item.url}
                          target={item.target || '_self'}
                          rel={item.nofollow || ''}
                          onMouseEnter={(e) => {
                            if (!isMobile) {
                              window.Dmp.hoverAction(item.dmp);
                            }
                          }}
                          dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                        ></a>
                      ) : item.iswxapp ? ( // 商城小程序
                        <>
                          {!isMobile ? (
                            <a
                              className="menulink"
                              style={convertStylesStringToObject(item.style)}
                              data-html-item={item.dmp}
                              data-url={item.url}
                              href={item.url}
                              target={item.target || '_self'}
                              rel={item.nofollow || ''}
                              onMouseEnter={(e) => {
                                if (!isMobile) {
                                  window.Dmp.hoverAction(item.dmp);
                                }
                              }}
                              dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                            ></a>
                          ) : (
                            <a
                              className="menulink"
                              style={convertStylesStringToObject(item.style)}
                              data-html-item={item.dmp}
                              data-url={item.url}
                              onClick={(e) => {
                                GotoMall(item.url, item.dmp, isMobile);
                              }}
                              dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                            ></a>
                          )}
                        </>
                      ) : item.isFansApp ? ( // 梦响+粉丝创作平台
                        <>
                          {!isMobile ? (
                            ''
                          ) : (
                            <a
                              className="menulink"
                              style={convertStylesStringToObject(item.style)}
                              data-html-item={item.dmp}
                              data-url={item.url}
                              onClick={(e) => {
                                GotoFansApp(item.dmp, isMobile);
                              }}
                              dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                            ></a>
                          )}
                        </>
                      ) : item.isenterprise ? ( // 企业微信
                        <>
                          {isMobile ? (
                            <a
                              className="menulink"
                              style={convertStylesStringToObject(item.style)}
                              data-html-item={item.dmp}
                              data-url={item.url}
                              href={item.url}
                              target={item.target || '_self'}
                              rel={item.nofollow || ''}
                              dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                            ></a>
                          ) : (
                            <div
                              className="menulink menulink3"
                              style={convertStylesStringToObject(item.style)}
                              onMouseEnter={(e) => {
                                window.Dmp.hoverAction(item.dmp);
                              }}
                            >
                              <span dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}></span>
                              <div className="code">
                                <img src={createFilePath(item.img)} alt={item.title} />
                              </div>
                            </div>
                          )}
                        </>
                      ) : item.iscar ? ( // 车型总览
                        <>
                          <div
                            className="menulink menulink2"
                            style={convertStylesStringToObject(item.style)}
                            onMouseEnter={(e) => {
                              if (!isMobile) {
                                window.Dmp.hoverAction(item.dmp);
                              }
                            }}
                            onClick={() => {
                              setSecordindex(0);
                              setCarindex(0);
                              if (!isMobile) {
                                setMenunum(index);
                                window.Dmp.clickAction(item.dmp);
                                windowhidden();
                              } else {
                                setMenunum(menunum === index ? -1 : index);
                                window.Dmp.decideAction(item.dmp, menunum === index ? false : true);
                              }
                            }}
                            dangerouslySetInnerHTML={{ __html: item.title ? item.title.replaceHtml() : '' }}
                          ></div>

                          {menunum === index && (
                            <div className="expand carexpand" style={convertStylesStringToObject(car.style)}>
                              {!isMobile && (
                                <div
                                  className="close"
                                  onClick={() => {
                                    setMenunum(-1);
                                    closewindowhidden();
                                  }}
                                  data-html-item={car.closedmp}
                                ></div>
                              )}
                              <div className="lists">
                                <div className="tabs">
                                  {car.tabs.map((tabsitem, tabsindex) => {
                                    return (
                                      <div
                                        className={`tabsitem ${carindex === tabsindex ? 'on' : ''}`}
                                        key={tabsindex}
                                        style={convertStylesStringToObject(tabsitem.style)}
                                        data-html-item={tabsitem.dmp}
                                        onClick={(e) => {
                                          setCarindex(tabsindex);
                                        }}
                                        dangerouslySetInnerHTML={{ __html: tabsitem.title ? tabsitem.title.replaceHtml() : '' }}
                                      ></div>
                                    );
                                  })}
                                </div>
                                <div className="car">
                                  {car.tabs[carindex].children.map((caritem, carindex) => {
                                    return (
                                      <div className="item" key={carindex}>
                                        <a
                                          className="top"
                                          data-html-item={caritem.linkdmp}
                                          data-url={caritem.url}
                                          href={caritem.url}
                                          target={'_self'}
                                        >
                                          {isMobile && <img className="img" src={createFilePath(caritem.img)} alt={caritem.name} />}
                                          <div
                                            className="name"
                                            dangerouslySetInnerHTML={{ __html: caritem.name ? caritem.name.replaceHtml() : '' }}
                                          ></div>
                                          <div
                                            className="price"
                                            dangerouslySetInnerHTML={{ __html: caritem.price ? caritem.price.replaceHtml() : '' }}
                                          ></div>
                                          {!isMobile && <img className="img" src={createFilePath(caritem.img)} alt={caritem.name} />}
                                        </a>
                                        <div className="bottom">
                                          <div className="look">
                                            {caritem.threeDurl && (
                                              <a
                                                className="threeD"
                                                data-html-item={caritem.threeDdmp}
                                                data-url={caritem.threeDurl}
                                                href={caritem.threeDurl}
                                                target={'_blank'}
                                                dangerouslySetInnerHTML={{
                                                  __html: caritem.threeDname ? caritem.threeDname.replaceHtml() : '3D看车'
                                                }}
                                                rel="nofollow noreferrer"
                                              ></a>
                                            )}
                                            {caritem.immdurl && (
                                              <a
                                                className="immd"
                                                data-html-item={caritem.immddmp}
                                                data-url={caritem.immdurl}
                                                href={caritem.immdurl}
                                                target={'_blank'}
                                                dangerouslySetInnerHTML={{
                                                  __html: caritem.immdname ? caritem.immdname.replaceHtml() : '探索先进技术'
                                                }}
                                                rel="nofollow noreferrer"
                                              ></a>
                                            )}
                                          </div>
                                          <div className="control">
                                            {caritem.testurl && (
                                              <a
                                                className="test"
                                                data-html-item={caritem.testdmp}
                                                data-url={caritem.testurl}
                                                href={caritem.testurl}
                                                target={'_self'}
                                                dangerouslySetInnerHTML={{
                                                  __html: caritem.testname ? caritem.testname.replaceHtml() : '预约试驾 >'
                                                }}
                                              ></a>
                                            )}
                                            {caritem.url && (
                                              <a
                                                className="detail"
                                                data-html-item={caritem.detaildmp}
                                                data-url={caritem.url}
                                                href={caritem.url}
                                                target={'_self'}
                                                dangerouslySetInnerHTML={{
                                                  __html: caritem.detailname ? caritem.detailname.replaceHtml() : '了解车型 >'
                                                }}
                                              ></a>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      ) : item.issecord ? (
                        <>
                          <div
                            className="menulink menulink2"
                            style={convertStylesStringToObject(item.style)}
                            onMouseEnter={(e) => {
                              if (!isMobile) {
                                window.Dmp.hoverAction(item.dmp);
                              }
                            }}
                            onClick={() => {
                              setSecordindex(0);
                              setCarindex(0);
                              if (!isMobile) {
                                setMenunum(index);
                                window.Dmp.clickAction(item.dmp);
                                windowhidden();
                              } else {
                                setMenunum(menunum === index ? -1 : index);
                                window.Dmp.decideAction(item.dmp, menunum === index ? false : true);
                              }
                            }}
                            dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                          ></div>

                          {menunum === index && (
                            <div className="expand" style={convertStylesStringToObject(item.expand.style)}>
                              {!isMobile && (
                                <div
                                  className="close"
                                  onClick={() => {
                                    setMenunum(-1);
                                    closewindowhidden();
                                  }}
                                  data-html-item={item.expand.closedmp}
                                ></div>
                              )}
                              <div className="lists">
                                <div className="tabs">
                                  {item.expand.tabs.map((tabsitem, tabsindex) => {
                                    return (
                                      <React.Fragment key={tabsindex}>
                                        {tabsitem.iswxapp && isMobile ? ( // 商城小程序
                                          <a
                                            className={`tabsitem ${secordindex === tabsindex ? 'on' : ''}`}
                                            style={convertStylesStringToObject(tabsitem.style)}
                                            data-html-item={tabsitem.dmp}
                                            data-url={tabsitem.url}
                                            onMouseEnter={(e) => {
                                              setSecordindex(tabsindex);
                                              if (!isMobile) {
                                                swiperEl.current.swiper.slideTo(tabsindex + 3);
                                                swiperEr.current.swiper.slideTo(item.expand.tabs.length - tabsindex + 1);
                                              }
                                            }}
                                            onClick={(e) => {
                                              GotoMall(tabsitem.url, tabsitem.dmp, isMobile);
                                            }}
                                            dangerouslySetInnerHTML={{ __html: tabsitem.title.replaceHtml() }}
                                          ></a>
                                        ) : tabsitem.isFansApp ? ( // 商城小程序
                                          <>
                                            {isMobile && (
                                              <a
                                                className={`tabsitem ${secordindex === tabsindex ? 'on' : ''}`}
                                                style={convertStylesStringToObject(tabsitem.style)}
                                                data-html-item={tabsitem.dmp}
                                                data-url={tabsitem.url}
                                                onMouseEnter={(e) => {
                                                  setSecordindex(tabsindex);
                                                }}
                                                onClick={(e) => {
                                                  GotoFansApp(tabsitem.dmp, isMobile);
                                                }}
                                                dangerouslySetInnerHTML={{ __html: tabsitem.title.replaceHtml() }}
                                              ></a>
                                            )}
                                          </>
                                        ) : (
                                          <a
                                            className={`tabsitem ${secordindex === tabsindex ? 'on' : ''}`}
                                            style={convertStylesStringToObject(tabsitem.style)}
                                            data-html-item={tabsitem.dmp}
                                            data-url={tabsitem.url}
                                            onMouseEnter={(e) => {
                                              setSecordindex(tabsindex);
                                              if (!isMobile) {
                                                swiperEl.current.swiper.slideTo(tabsindex + 3);
                                                swiperEr.current.swiper.slideTo(item.expand.tabs.length - tabsindex + 1);
                                              }
                                            }}
                                            href={tabsitem.url}
                                            target={tabsitem.target || '_self'}
                                            rel={item.nofollow || ''}
                                            dangerouslySetInnerHTML={{ __html: tabsitem.title.replaceHtml() }}
                                          ></a>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </div>
                                {!isMobile && (
                                  <div className="ghap">
                                    <Swiper
                                      className="swiperEl"
                                      ref={swiperEl}
                                      direction={'vertical'}
                                      slidesPerView={2.3}
                                      observer={true}
                                      observeSlideChildren={true}
                                      loop={true}
                                      initialSlide={0}
                                      centeredSlides={true}
                                      spaceBetween={50}
                                      allowTouchMove={false}
                                    >
                                      {item.expand.tabs.map((tabsitem, tabsindex) => {
                                        return (
                                          <SwiperSlide className="item" key={tabsindex}>
                                            <img className="img" src={createFilePath(tabsitem.img)} alt={tabsitem.title} />
                                          </SwiperSlide>
                                        );
                                      })}
                                    </Swiper>
                                    <Swiper
                                      className="swiperEr"
                                      ref={swiperEr}
                                      direction={'vertical'}
                                      slidesPerView={2}
                                      observer={true}
                                      observeSlideChildren={true}
                                      loop={true}
                                      initialSlide={0}
                                      spaceBetween={50}
                                      allowTouchMove={false}
                                    >
                                      {item.expand.tabs.reverse().map((tabsitem, tabsindex) => {
                                        return (
                                          <SwiperSlide className="item" key={tabsindex}>
                                            <img className="img" src={createFilePath(tabsitem.img)} alt={tabsitem.title} />
                                          </SwiperSlide>
                                        );
                                      })}
                                    </Swiper>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        <a
                          className="link"
                          style={convertStylesStringToObject(item.style)}
                          data-html-item={item.dmp}
                          data-url={item.url}
                          href={item.url}
                          target={item.target || '_self'}
                          rel={item.nofollow || ''}
                          dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                        ></a>
                      )
                    ) : (
                      ''
                    )}
                  </div>
                );
              })}
            </div>
          )}
          {othermenu && ( // 右侧菜单
            <div className="othermenu" style={convertStylesStringToObject(othermenu.style)}>
              {othermenu.lists.map((item, index) => {
                return !item.issearch ? (
                  <a
                    key={index}
                    className={`link ${item.btnclass}`}
                    style={convertStylesStringToObject(item.style)}
                    data-html-item={item.dmp}
                    data-url={item.url}
                    href={item.url}
                    target={item.target || '_self'}
                    rel={item.nofollow || ''}
                    dangerouslySetInnerHTML={{ __html: item.title.replaceHtml() }}
                  ></a>
                ) : (
                  <div key={index} className={`link ${item.btnclass}`} style={convertStylesStringToObject(item.style)}>
                    {!isMobile ? (
                      <i
                        className="icon"
                        data-html-item={item.dmp}
                        onClick={() => {
                          if (searchValue !== '') {
                            window.open(`/search?keyword=${searchValue}`);
                            setSearchValue('');
                            setInputFlag(false);
                          } else {
                            setInputFlag(!inputFlag);
                          }
                        }}
                      ></i>
                    ) : (
                      <i
                        className="icon"
                        data-html-item={item.dmp}
                        onClick={() => {
                          window.open('/search');
                        }}
                      ></i>
                    )}
                    {inputFlag ? (
                      <input
                        type="text"
                        className="search"
                        onBlur={(e) => {
                          window.Dmp.msgAction(item.keydmp, e.target.value);
                        }}
                        onInput={(e) => {
                          setSearchValue(e.target.value);
                        }}
                      />
                    ) : (
                      ''
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
